module.exports = __webpack_public_path__ + "static/a-home-behind-the-lens-social-banners-1200x630-2577e6818f09e6c260f0f43aedd8d23f.jpg";